import React from "react";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import { useFormContext } from "react-hook-form";
import { isNumber } from "lodash";

function InputSetting({ setting, setParentState, styles = {}, name, validations = {} }) {
  const {
    register,
    formState: { errors },
    setValue,
    trigger,
  } = useFormContext();

  if (validations?.type === "number" && !validations?.validate)
    validations.validate = (value) =>
      (Number(value) && isNumber(Number(value))) || "Please enter a valid number";

  return (
    <Box
      component="form"
      sx={{
        width: "100%",
        marginBottom: "2rem",
        ...styles,
      }}
      noValidate
      autoComplete="off"
    >
      <TextField
        variant="outlined"
        {...(name ? register(name, validations) : {})}
        value={setting.field_value}
        label={setting.en_field_label}
        onChange={(e) => {
          setParentState(e.target.value);
          if (name) {
            setValue(name, e.target.value);
            trigger(name);
          }
        }}
        sx={{
          width: "100%",
          "& input": {
            padding: "16px",
          },
        }}
        error={errors[name]?.message || false}
        helperText={errors[name]?.message}
      />
    </Box>
  );
}

export default InputSetting;
